<template>
  <div class="login-screen">

    <!-- Loading Animation -->
    <transition name="fade">
      <div class="ld-loading" v-if="loadingVisible">
        <svg class="ls-animation" version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
          <path d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
              <animateTransform attributeName="transform" attributeType="XML"  type="rotate" dur="1s" from="0 50 50" to="360 50 50" repeatCount="indefinite" />
          </path>
        </svg>
      </div>
    </transition> 


    <div class="layout" v-if="!settingsVisible">
      <img :src="logoURL" alt="" class="ld-logo">
      <h1 class="ld-title">{{$t(loginStatus == 'register'? "Registrierung" : "Login")}}</h1>

      <div class="ld-section" v-if="loginStatus == 'login'">

        <div :style="{'background': loginInformationError? 'red' : 'rgb(35, 107, 47)'}" class="ld-information" v-if="loginInformation">
          <Check v-if="!loginInformationError"/>
          <Close v-else/>
          <span >{{ $t(loginInformation) }}</span>
        </div>

        <!-- E-Mail -->
        <div class="form-element">
          <label class="form-label" for="ld-email">{{ $t('E-Mail') }}</label>
          <input id="ld-email" :placeholder="$t('E-Mail')" class="form-control" type="text" v-model="loginData.email">
        </div>

        <!-- Passwort -->
        <div class="form-element">
          <label class="form-label" for="ld-password">{{ $t('Passwort') }}</label>
          <input id="ld-passwort" :placeholder="$t('Passwort')" class="form-control" type="password" v-model="loginData.passwort">
        </div>

        <transition name="fade">
          <p class="form-error" v-if="loginError">{{$t(loginError)}}</p>
        </transition>

        <button class="form-button form-button-switch" @click="login()">{{ $t('Login') }}</button>
        <button class="form-button" @click="cancel()">{{ $t('Abbrechen') }}</button>
        <button class="form-button" @click="toggleLoginStatus()">{{ $t('Zur Registrierung') }}</button>
      </div>


      <div class="ld-section ld-register" v-if="loginStatus == 'register'">
        <!-- Vorname --> 
        <div class="form-inline form-element">
          <label class="form-label" for="vorname">{{ $t('Vorname') }}<span>*</span></label>
          <input id="vorname" :placeholder="$t('Vorname')" class="form-control" type="text" v-model="registerData.vorname">
        </div>

        <!-- Nachname -->
        <div class="form-inline form-element">
          <label class="form-label" for="nachname">{{ $t('Nachname') }}<span>*</span></label>
          <input id="nachname" :placeholder="$t('Nachname')" class="form-control" type="text" v-model="registerData.nachname">
        </div>

        <!-- E-Mail -->
        <div class="form-element">
          <label class="form-label" for="email">{{ $t('E-Mail') }}<span>*</span></label>
          <input id="email" :placeholder="$t('E-Mail')" class="form-control" type="text" v-model="registerData.email">
        </div>

        <!-- Sprache -->
        <div class="form-element">
          <label class="form-label" for="language">{{ $t('Sprache') }}<span>*</span></label>
          <input id="language" :placeholder="$t('Sprache')" class="form-control" type="text" v-model="registerData.language">
        </div> 

        <!-- Firma -->
        <div class="form-element">
          <label class="form-label" for="firma">{{ $t('Unternehmen') }}<span>*</span></label>
          <input id="firma" :placeholder="$t('Unternehmen')" class="form-control" type="text" v-model="registerData.firma">
        </div>  

        <!-- Land -->
        <div class="form-element">
          <label class="form-label" for="land">{{ $t('Land') }}</label>
          <input id="land" :placeholder="$t('Land')" class="form-control" type="text" v-model="registerData.land">
        </div>  

        <!-- Adresse -->
        <div class="form-element">
          <label class="form-label" for="adresse">{{ $t('Adresse') }}</label>
          <input id="adresse" :placeholder="$t('Adresse')" class="form-control" type="text" v-model="registerData.adresse">
        </div>  

        <!-- Telefonnummer -->
        <div class="form-element">
          <label class="form-label" for="mobilnummer">{{ $t('Telefonnummer') }}</label>
          <input id="mobilnummer" :placeholder="$t('Telefonnummer')" class="form-control" type="text" v-model="registerData.mobilnummer">
        </div>  

        <!-- Passwort -->
        <div class="form-element">
          <label class="form-label" for="passwort">{{ $t('Passwort') }}<span>*</span></label>
          <input id="passwort" :placeholder="$t('Passwort')" class="form-control" type="password" v-model="registerData.passwort">
        </div>  

        <!-- Repeat Passwort -->
        <div class="form-element">
          <label class="form-label" for="passwort-repeat">{{ $t('Passwort wiederholen') }}<span>*</span></label>
          <input id="passwort-repeat" :placeholder="$t('Passwort wiederholen')" class="form-control" type="password" v-model="registerData.passwortRepeat">
        </div>  
        
        <transition name="fade">
          <p class="form-error" v-if="registerError">{{registerError}}</p>
        </transition>

        <button class="form-button form-button-switch" @click="register()">{{ $t('Registrieren') }}</button>  
        <button class="form-button" @click="cancel()">{{ $t('Abbrechen') }}</button>
        <button class="form-button" @click="toggleLoginStatus()">{{ $t('Zum Login') }}</button>

      </div>
      
    </div>
    <AudioVideoDialogue v-else :from="'login'" :loginDialogueVisible="this.loginDialogueVisible" :settingsVisible="this.settingsVisible" :toggleLogin="this.toggleLogin" :toggleSettingsInLogin="this.toggleSettings"></AudioVideoDialogue>
  </div>
</template>
 
<script>
import {getInitials} from "@/utils/string-utils";
import MediaManager from "@/api/MediaManager";
import {mapGetters,mapMutations} from 'vuex';
import AudioVideoDialogue from "@/components/flux360/LoginComponents/AudioVideoDialogue";
import axios from "axios";
import Check from 'vue-material-design-icons/Check.vue'
import Close from 'vue-material-design-icons/Close.vue'
import jwt_decode from "jwt-decode";
export default {
  components: {AudioVideoDialogue,Check,Close},
  inject: ['toggleLoginDialogue'],
  props: {
    toggleLogin: Function,
    toggleLoginDialogue: Function,
    loginDialogueVisible: Boolean,
  },
	data: () => ({
    status: 'start',
    settingsVisible: false,
    loginStatus: "login",
    loginError: null,
    registerError: null,
    loginInformation: null,
    loginInformationError: false,
    loadingVisible: false,

    registerData: {
      vorname: null,
      nachname: null,
      email: null,
      language: null,
      adresse: null,
      land: null,
      mobilnummer: null,
      passwort: null,
      passwortRepeat: null,
      firma: null,
    },  
    loginData: {
      email: null,
      passwort: null,
    },
	}),
  computed: {
    ...mapGetters(['panoramaTour', 'localUser', 'users', 'localUserID','logoURL','loggedIn']),
  },
  mounted() {
    this.$store.commit('setVideoOn', false);
    this.$store.commit('setAudioOn', false);
    window.addEventListener('openMeetingRegister',this.openFromButton);
  },
  methods: {
    ...mapMutations(["setLoggedIn",'updateUser']),
    cancel() {
      const self = this;
      let userToBeRemoved = [];
      this.users.forEach((u) => {
        if(u.id !== self.localUserID){
          userToBeRemoved.push(u.id);
        }
      });
      userToBeRemoved.forEach((id) => {
        self.$store.commit("removeUser", id);
      });
      this.toggleLoginDialogue();
      this.loginInformation = null;
      this.loginError = null;
      this.loginStatus = "login";
    },
    toggleSettings() {
      this.settingsVisible = !this.settingsVisible;
    },
    toggleLoginStatus(){
      this.loginStatus = this.loginStatus == 'register' ? 'login' : 'register';
    },
    toggleLoadingScreen(){
      this.loadingVisible = !this.loadingVisible;
    },
    register() {
      if(!this.validateRegister())
        return;

      this.toggleLoadingScreen();

      const options = {
        method: 'POST',
        url: 'https://auth.ar-cms.de/api/vrm/register',
        headers: {'Content-Type': 'application/json'},
        data: {
          mail: this.registerData.email,
          name: this.registerData.vorname + " " + this.registerData.nachname,
          password: this.registerData.passwort,
          adress: this.registerData.adresse,
          country: this.registerData.land,
          phone: this.registerData.mobilnummer,
          language: this.registerData.language,
          company: this.registerData.firma,
        }
      };

      axios.request(options).then((response) => {
        this.loginInformation = "Ihre Registrierung war erfolgreich!\nSie haben eine E-Mail erhalten, mit der Sie ihren Account freischalten können";
        this.loginInformationError = false;
        this.toggleLoginStatus();
        this.toggleLoadingScreen();
      }).catch((error) => {
        this.registerError = this.$t("Die Email wurde bereits registriert");
        this.toggleLoadingScreen();
      });
    },
    login() {
      this.toggleLoadingScreen();

      const form = new URLSearchParams();
      form.append("username",this.loginData.email);
      form.append("password",this.loginData.passwort);
      form.append("client_id","venjakob");
      form.append("grant_type","password");
      const options = {
        method: 'POST',
        url: 'https://auth.ar-cms.de/auth/realms/Venjakob/protocol/openid-connect/token',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        data: form
      };
      
      axios.request(options).then((response) => {
        var decoded = jwt_decode(response.data.access_token);
        console.log(decoded);

        localStorage.setItem("accessToken",response.data.access_token);
        let role = decoded.resource_access.venjakob ? decoded.resource_access.venjakob.roles[0].toLowerCase() : "visitor";
        if(decoded.family_name == "Christian Nüsser")
          role = "moderator";
        this.localUser.setRole(role);
        this.setLoggedIn(true);

        let originalURL = new URL(window.location);
        let search_params = originalURL.searchParams;
        console.log(search_params);
        if(search_params.get("sessionID") == "none" ) {
          // Prevent Communication
          this.toggleLoadingScreen();
          this.toggleLoginDialogue();

        }else{

          // Default Login
          const name = decoded.family_name;
          const acronym = getInitials(name);
          let connect = this.$store.dispatch('changeNameAndAcronym', {name, acronym, role});
          connect.then(() => {
            MediaManager.getUserAvatar(this.localUser);
            this.toggleSettings();
            this.toggleLoadingScreen();
          })
        }

      }).catch((error) =>{
        console.log(error);
        this.loginError = "Die Email und/oder das Passwort ist falsch";
        this.toggleLoadingScreen();
      });

    },
    openFromButton(){
      if(!this.loggedIn){
        this.loginInformation = "Sie müssen angemeldet sein, um einen Termin zu Vereinbaren!\nSie können hier einen Account anlegen";
        this.loginInformationError = true;
        this.toggleLoginDialogue();
      }
    },
    validateRegister(){
      this.registerError = "";

      let missing = [];
      if(!document.getElementById("vorname").value)
        missing.push(this.$t('Vorname'));
      if(!document.getElementById("nachname").value)
        missing.push(this.$t('Nachname'));
      if(!document.getElementById("email").value)
        missing.push(this.$t('E-Mail'));
      if(!document.getElementById("language").value)
        missing.push(this.$t('Sprache'));
      if(!document.getElementById("firma").value)
        missing.push(this.$t('Unternehmen'));
      if(!document.getElementById("passwort").value)
        missing.push(this.$t('Passwort'));

      let missingError = missing.length == 0;
      if(!missingError){
        this.registerError += this.$t('Fehlende Angaben: ');
        for (let i = 0; i < missing.length; i++) 
          this.registerError += missing[i] + (i != missing.length-1 ? ", " : "\n");
      }

      let passwordError = document.getElementById("passwort").value == document.getElementById("passwort-repeat").value;
      if(!passwordError)
        this.registerError += this.$t('Passwort stimmt nicht überein');
      
      return missingError && passwordError;
    }
	},
}
</script>

<style scoped>
.login-screen {
  position: absolute;
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(20px);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(58, 58, 58, 0.8);
  color: white;
  z-index: 2;
  overflow-y: auto;
}
@-moz-document url-prefix() {
  .login-screen{
    background: rgba(68, 68, 68, 0.96);
  }
}
.layout{
  height: 100%;
  width: 50%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 0 auto 0 auto;
  padding-top: 50px;
  padding-bottom: 30px;
}
.layout > *{
  margin-bottom: 5px;
}
.ld-title{
  text-align: center;
  font-size: 30px;
  margin-bottom: 30px;
}
#date{
  color: #d0d0d0;
  font-size: 1em;
  text-align: center;
  margin-bottom: 50px;
}
.ld-logo{
  filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0.226));
  width: 350px;
  margin: 0 auto;
  margin-bottom: 20px;
}
.ld-section{
  max-height: 95%;
  overflow: auto;
  padding-left: 200px;
  padding-right: 200px;
}
.ld-information{
  font-size: 15px;
  margin: 10px;
  padding: 15px;
  padding-top: 5px;
  color: white;
  border-radius: 5px;
  white-space: pre-wrap; 
  word-wrap: break-word;
}
.login-screen .material-design-icon{
  display: block;
  margin: auto;
  height: 50px !important;
  width: 50px !important;
}
.login-screen .material-design-icon > .material-design-icon__svg {
  height: 50px !important;
  width: 50px !important;
}
.ld-loading{
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 10;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}


.form-control {
  width: 100%;
  padding: 8px 12px;
  margin-top: 5px;
  margin-bottom: 10px;
  display: inline-block;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  font-size: 15px;
}
.form-label{
  display: block;
  font-size: 15px;
}
.form-button {
  width: calc(50% - 20px);
  background-color: #046976;
  color: white;
  padding: 14px 20px;
  margin: 20px 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.form-button:hover {
  background-color: #00424b;
}
.form-button-switch{
  width: 100%;
  margin: 0;
  margin-bottom: 0px;
  margin-top: 15px;
}
.form-inline{
  width: calc(50% - 20px);
  display: inline-block;
}
.form-element {
  border-radius: 5px;
  margin: 10px;
  text-align: left;
}
.ld-register span{
  color: red;
  margin-left: 7px;
  font-size: 20px;
  line-height: 0;
}
.form-error{
  margin: 10px;
  padding: 10px;
  color: white;
  background: red;
  border-radius: 5px;
  white-space: pre-wrap; 
  word-wrap: break-word;
}
</style>